import { RichText } from "@/components/richText/richText.component";

import {
  type OptionCardGridBlock,
  OptionCardGridItem,
  type OptionCardGridItemData,
} from "./optionCardGridItem.component";

export const OptionCardGrid = ({ block }: OptionCardGridProps) => {
  const cards = block.cards ?? [];
  const hasTitle = (block.title ?? []).length > 0;

  if (!hasTitle || cards.length === 0) return null;

  const validCards = cards.filter((card): card is OptionCardGridItemData =>
    Boolean(card?._key),
  );

  return (
    <section data-testid="option-card-grid" className="w-full py-10 md:py-14">
      <div className="mx-auto flex w-full max-w-336 flex-col gap-10 px-5 sm:px-6 md:px-8">
        <div className="text-greyscale-headline text-center">
          <RichText>{block.title}</RichText>
        </div>

        <ul
          className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
          data-testid="option-card-grid-list">
          {validCards.map((card) => (
            <OptionCardGridItem key={card._key} card={card} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export type OptionCardGridProps = {
  block: OptionCardGridBlock;
};
